import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { CircularProgressProps } from '@material-ui/core/CircularProgress';
import { Backdrop } from '@material-ui/core';
import { SCircularLoader } from '../circular-loader';

export interface CircularLoaderProps extends CircularProgressProps {
  backdrop?: boolean;
  backgroundColor?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      zIndex: 20
    },
    loader: {
      position: 'absolute',
      left: -26
    },
    backdrop: {
      zIndex: 9999,
      color: theme.palette.common.white,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute'
    }
  })
);

export function PageLoader({
  backdrop = true,
  backgroundColor = '#fff',
  ...props
}: CircularLoaderProps) {
  const classes = useStyles();

  return (
    <Backdrop
      className={classes.backdrop}
      style={{ backgroundColor }}
      open={backdrop}>
      <div className={classes.root}>
        <SCircularLoader
          className={classes.loader}
          size={60}
          thickness={6}
          {...props}
        />
      </div>
    </Backdrop>
  );
}
